import { combineReducers } from '@reduxjs/toolkit'
import editorSlice from 'store/features/editor/slice'
import projectSlice from 'store/features/project/slice'
import projectDataSlice from 'store/features/projectData/slice'
import userSlice from 'store/features/user/slice'
import recentlyUsedMediaSlice from 'store/features/recentlyUsedMedia/slice'
import aiVideoSlice from 'store/features/aiVideo/slice'
import aiAvatarSlice from 'store/features/aiAvatar/slice'
import audioSlice from 'store/features/audio/slice'
import aiImageSlice from 'store/features/aiImage/slice'
import ttsSlice from 'store/features/tts/slice'
import creditsSlice from 'store/features/credits/slice'
import cacheSlice from 'store/features/cache/slice'
import aiLibVideoSlice from 'store/features/aiLibVideo/slice'
import aiLibImageSlice from 'store/features/aiLibImage/slice'
import voiceCatalogSlice from 'store/features/voiceCatalog/slice'
import campaignSlice from 'store/features/campaign/slice'

const combinedReducers = combineReducers({
  editor: editorSlice.reducer,
  user: userSlice.reducer,
  project: projectSlice.reducer,
  projectData: projectDataSlice.reducer,
  recentlyUsedMedia: recentlyUsedMediaSlice.reducer,
  aiImage: aiImageSlice.reducer,
  tts: ttsSlice.reducer,
  aiVideo: aiVideoSlice.reducer,
  aiAvatar: aiAvatarSlice.reducer,
  audio: audioSlice.reducer,
  credits: creditsSlice.reducer,
  cache: cacheSlice.reducer,
  aiLibVideo: aiLibVideoSlice.reducer,
  aiLibImage: aiLibImageSlice.reducer,
  voiceCatalog: voiceCatalogSlice.reducer,
  campaign: campaignSlice.reducer
})

export default combinedReducers
